module.exports = __webpack_public_path__ + "img/26.02045ad3.jpg";